import React from 'react';

function Reload({ width }) {
  return (
    <svg width={width || '18'} viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.3999 10.0089H17.3879L12.9329 14.4639L8.4779 10.0089H12.5729C12.5999 8.6229 12.0779 7.2459 11.0159 6.1839C8.9099 4.0779 5.4899 4.0779 3.3839 6.1839C1.2779 8.2899 1.2779 11.7189 3.3839 13.8249C5.0399 15.4809 7.5239 15.8319 9.5219 14.8779L10.8449 16.2009C8.0999 17.8299 4.4999 17.4699 2.1059 15.0939C-0.7021 12.2859 -0.6931 7.7319 2.1149 4.9239C4.9499 2.1069 9.4769 2.0979 12.2939 4.9149C13.6979 6.3189 14.3999 8.1639 14.3999 10.0089Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Reload;
